import React from 'react';
import { Link } from 'react-router-dom';
import { MenuBook } from '@mui/icons-material';
import {
  AppBar,
  Avatar,
  CardHeader,
  Tooltip,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useAuth } from 'oidc-react';
import AppDrawer from './AppDrawer';
import FeedbackForm from './FeedbackForm';
import usePerson from '../hooks/usePerson';
import { isPuffdirAdmin } from '../shared/serviceHandler';
import SearchBar from './SearchBar';

function AppNavigation() {
  // const navigate = useNavigate();
  const auth = useAuth();
  const { email } = auth.userData.profile;
  const { person, loading } = usePerson(email);

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <IconButton
              onClick={() => setDrawerOpen(true)}
              size="large"
              edge="start"
              aria-label="menu"
            >
              <MenuBook color="secondary" />
            </IconButton>
            <Typography
              variant="h6"
              color="secondary"
              component={Link}
              to="/"
              sx={{
                textDecoration: 'none',
                flexGrow: 1,
                display: { xs: 'none', sm: 'block' },
              }}
            >
              Puffdirectory
            </Typography>
            <form noValidate autoComplete="off">
              <SearchBar />
            </form>
            {loading ? null : (
              <span>
                <Typography
                  color="secondary"
                  component={Link}
                  to={`/person/${email.replace('@gopuff.com', '')}`}
                >
                  <Tooltip
                    title={`${person.full_name} ${
                      isPuffdirAdmin(auth) ? '(Admin)' : ''
                    }`}
                    sx={{ pr: 0 }}
                  >
                    <CardHeader
                      avatar={
                        <Avatar
                          alt={person.full_name}
                          src={person.slack_photo}
                          sx={{
                            width: 30,
                            height: 30,
                            border: isPuffdirAdmin(auth)
                              ? '2px solid white'
                              : 'none',
                          }}
                        />
                      }
                    />
                  </Tooltip>
                </Typography>
              </span>
            )}
          </Toolbar>
        </AppBar>
      </Box>
      <AppDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      <FeedbackForm fullName={person.full_name} />
    </>
  );
}

export default AppNavigation;
